import utils from "../_Utils/utilsMaster";
import { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { CurrentPContext, MasterContext, UserContext } from "../ContextApi/context";
import { AccountCircle, ArrowBack, Circle, Login, Logout, MenuOpenSharp, MenuSharp, PersonOutlineSharp } from '@mui/icons-material';
import ArrowRight from '@mui/icons-material/ArrowRight';
import { useHistory } from "react-router-dom";
import { useSwipeable } from 'react-swipeable';
import TopBigSlides from "../DTechComp/TopBigSlides";
import ConnUrls from '../Connections/ConnectURL';
import PopUpClearComp from "../DTechComp/PopUpClearComp";
import LoginPage from "../UsersLogs/LoginPage";
import { CityChip } from "../DTechComp/CityPicker/CityPicker";

const MobiMenu = (props) => {

  const [master, setMaster] = useContext(MasterContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);

  const [user, setUser, UserEffectFunction] = useContext(UserContext);

  const [mnuShow, setMnuShow] = useState(false);
  const [thePopUp, setThePopUp] = useState("");

  const [topSlides, setTopSlides] = useState();
  const history = useHistory();

  useEffect(() => {
    UserEffectFunction();
    setTopSlides(<TopBigSlides TopImages={master.mobiMenuTopImages} />)

  }, [])

  useEffect(() => {
    setMnuShow(props.mnuShow)
  }, [props.mnuShow])

  const loginUsr = () => {

    setThePopUp(
      <PopUpClearComp
        popFullComp={"specialPopComp onTopOfAll"}
        cssStyl={"noPadding "}
        btnFStyle={"fatInBtn"}
        closePop={() => setThePopUp()}
        insideCss={"noPadding "}
        theInsideComp={
          <LoginPage
            theInsideComp={""}
            backFunc={true}
            closeMeFuc={() => setThePopUp()}
            shoTopStrp={(tf) => { }}
            scrollToTop={(stUp) => { }} />
        } />)

    setMnuShow(false);
  }

  const logOutUsr = () => {
    localStorage.removeItem('usrtoken');
    setUser();
    setMnuShow(false);
    history.go(0)
  }


  const mobileFlUserClick = () => {
    if (
      user === null ||
      user._id === null ||
      user.firstName === ""
    ) {
      setMnuShow(!mnuShow)
    }
    else {
      history.push("/MyOrders")
    }
  }

  const swipME = useSwipeable({
    // onSwipedLeft: (eventData) => alert("User Swiped Left!", eventData),
    // onSwipedRight: (eventData) => alert("User Swiped Right!", eventData),
    // swipeDuration: 500,
    // preventScrollOnSwipe: true,
    // trackMouse: true
  });


  return (
    <div className={"mobiMnuDiv"}  {...swipME}>
      <div id="mobiFloatLeftID" onClick={() => setMnuShow(!mnuShow)} className={`mobiFloatLeft ${!mnuShow ? "" : "mobiFloatLShow"}`}>
        <div className="mobiArr ms-aside-toggler ms-toggler pl-0" >
          <span className="ms-toggler-bar mybg-primary" />
          <span className="ms-toggler-bar mybg-primary" />
          <span className="ms-toggler-bar mybg-primary" />

        </div>
        {/* <MenuSharp className={"mobiArr"} sx={{}} /> */}
      </div>

      <div id="mobiMnuID" className={`mobiMnu ${!mnuShow ? "mobMnuSh" : ""}`}>
        <div className={"mobiMnuInWrap"}>
          <div className={"topSlidesWrap"}>{topSlides}</div>
          <div className={"fatLIne"}>
            <div className={"userDet"}>

              <div className={"CloseMobiBtn pointing"}>
                <div className={"usrDispOnMenu"}>
                  <span className={"big bold spaceTop"}>
                    <span> שלום </span>
                    {(user?.firstName != "null" && user?.firstName != "") ?
                      <span>{user?.firstName}</span> :
                      <span>אורח</span>}
                  </span>

                </div>
                <div className={"inOutOnMenu"}>
                  <div className={"inOutLogDiv"}>
                    {(user?._id != null) ?
                      <div className={"logOnDsk"}>
                        <Logout aria-hidden="true" onClick={() => logOutUsr()} />
                        <span className="inOutBott fullWidth">התנתקות</span>
                      </div> :
                      <div className={"logOnDsk"}>
                        <Login aria-hidden="true" onClick={() => loginUsr()} />
                        <span className="inOutBott fullWidth">התחברות</span>
                      </div>
                    }
                  </div>
                </div>
              </div>

            </div>

          </div>
          <div className={"MobiMenuMainMnu spacePadBig"}>
            {/* החלפת עיר (כולל "זהה לפי מיקום") - רק כשיש ערים מוגדרות */}
            <CityChip className="inMobiMenu" onClick={() => setMnuShow(false)} />
            {
              (user?._id != null) ?
                <div className={"mobiMnuLnkItm2 pointing"}>
                  <button type="button" className="btnReset mobiMnuLnkItm1"
                    onClick={() => { history.push("/MyProfile#"); setMnuShow(false) }}>
                    <PersonOutlineSharp aria-hidden="true" sx={{ color: 'black', fontSize: '1.2rem' }} className={"onRight"} />
                    <div className={"onRight mobiMnuTxt spaceRight pointing"}>
                      {`אזור אישי`}
                    </div>
                  </button>
                </div>
                : ""
            }
            {
              master.mainMenu.map((item, index) => {
                return (
                  <div key={index} className="mobiMnuLnkItm2 pointing"
                    onClick={() => history.push(`/${item.lnk}`)}>
                    <div colSpan={"2"}>
                      {item.txt}
                    </div>
                  </div>
                )
              })
            }
            <div key={"noINdex"} className="mobiMnuLnkItm2 pointing" aria-label="פתח תפריט נגישות"
              onClick={() => window.toggleA11yPanel && window.toggleA11yPanel()}>
              <div colSpan={"2"}>
                אפשרויות נגישות
              </div>
            </div>
          </div>

          <div className={"botmMnuLogoWrap"}>

            <div className={"botmMnuLogo"} onClick={() => { setMnuShow(!mnuShow); history.push("/") }}>
              <img className={"btmLgoImg"} src={`${ConnUrls.servMediasUrl}${master.mobiMenuBotLogo}`} alt={currentPage.altTags || currentPage.pageName || ""} />
            </div>
            <div className={"botmMnuLogoTxt"}>כל הזכויות שמורות ל-"אשדוד בתפריט"</div>
          </div>

        </div >
      </div>
      {thePopUp}
    </div>
  )

}

export default MobiMenu;
